import classes from "./DisabledVetForm.module.scss";
import { useSelectedFormContext } from "../../../../../context/SelectedForm/selected-form-context";
import { useEffect, useState, useMemo } from "react";
import {
  getSelectedFormDataHelper,
  getSelectedFormEntryDataHelper,
  saveFormHelper,
} from "../../../../../context/SelectedForm/selected-form-context.helper";
import {
  IFormEntryModel,
} from "../../../../../interfaces/form-entry.interface";
import {
  IFormFiledInterface,
} from "../../../../../interfaces/form-filed.interface";
import { useNavigate } from "react-router-dom";
import {
  IFormSettingModel,
} from "../../../../../interfaces/form-settings.interface";
import { Dialog } from "@progress/kendo-react-dialogs";
import { SelectedFormActionsEnum } from "../../../../../context/SelectedForm/selected-form-actions";
import { useFormContext } from "../../../../../context/Form/form-context";
import {
  onLoadForms
} from "../../../../../context/Form/form-helper";
import { CustomLoader } from "../../../../../components";
import { FormActionsEnum } from "../../../../../context/Form/form-actions";
import { useCallbackPrompt } from "../../../../../hooks/useCallbackPrompt";
import UnsavedFormDialog from "../../../../../components/CustomDialogs/UnsavedFormDialog/UnsavedFormDialog";
import { t } from "i18next";
import AuthService from 'src/services/authentication.service';
import { DisabledVetFormName } from "src/constants/form-names-constants";
import DisabledVetFormFirstSection from "./DisabledVetFormFirstSection";
import { useFormSectionDataFields } from "../useFormSectionDataFields";
import DisabledVetFormSecondSection from "./DisabledVetFormSecondSection";
import { DisabledVetFifthSectionInterface, IDisabledVetFifthSection } from "src/interfaces/forms/DisableVetForm/disable-vet-form-fifth-section";
import { DisabledVetFirstSectionInterface, IDisabledVetFirstSection } from "src/interfaces/forms/DisableVetForm/disable-vet-form-first-section";
import { DisabledVetFourthSectionInterface, IDisabledVetFourthSection } from "src/interfaces/forms/DisableVetForm/disable-vet-form-fourth-section";
import { DisabledVetSecondSectionInterface, IDisabledVetSecondSection } from "src/interfaces/forms/DisableVetForm/disable-vet-form-second-section";
import { DisabledVetThirdSectionInterface, IDisabledVetThirdSection } from "src/interfaces/forms/DisableVetForm/disable-vet-form-third-section";
import { DisabledVetSixthSectionInterface, IDisabledVetSixthSection } from "src/interfaces/forms/DisableVetForm/disable-vet-form-sixth-section";
import { DisabledVetEighthSectionInterface, IDisabledVetEighthSection } from "src/interfaces/forms/DisableVetForm/disable-vet-form-eighth-section";
import { DisabledVetSeventhSectionInterface, IDisabledVetSeventhSection } from "src/interfaces/forms/DisableVetForm/disable-vet-form-seventh-section";
import DisabledVetSeventhSection from "./DisabledVetFormSeventhSection";
import DisabledVetEighthSection from "./DisabledVetFormEighthSection";
import DisabledVetSixthSection from "./DisabledVetFormSixthSection";
import DisabledVetThirdSection from "./DisabledVetFormThirdSection";
import DisabledVetFourthSection from "./DisabledVetFormFourthSection";
import DisabledVetFifthSection from "./DisabledVetFormFifthSection";
import DisabledVetFormPDFView from "src/pages/Shared/DisabledVetFormPDFView/DisabledVetFormPDFView";
import { FormHeader } from "../Shared/FormHeader/FormHeader";
import { submitted } from "src/constants/submission-form-status-constants";
import { useIsFormActive } from "../useIsFormActive";
import { DisabledVetDisclaimer } from "./DisabledVetDisclaimer";
import { DisabledVetFilingWindowDisclaimer } from "./DisabledVetFilingWindowDisclaimer";

interface FormEntry {
  formEntryId?: number;
  isAdminPreview?: boolean;
  formId?: number;
}

export default function DisabledVetForm(props: FormEntry): JSX.Element {
    const { isAuthorized } = AuthService.getInstance();

    const { isAdminPreview, formEntryId, formId } = props;
    const { formState, formDispatch } = useFormContext();
    const { selectedFormDispatch, selectedFormState } = useSelectedFormContext();
    const { loading } = formState;
    const { isLoading } = selectedFormState;
    const [formDataFields, setFormDataFields] = useState<Array<IFormFiledInterface>>();
    const [formEntry, setFormEntry] = useState<IFormEntryModel>();
    const formSettings = useMemo(() => {
      let formSettings = selectedFormState.formSettings ?? undefined;
      if (
          !isAuthorized ||
          isAdminPreview ||
          selectedFormState.formEntry?.submissionStatus == submitted
       ) {
        formSettings = { ...formSettings, isReadOnly: true };
       }
       return formSettings;
    }, [selectedFormState.formSettings, selectedFormState.formEntry, isAuthorized, isAdminPreview]);

    const [formSecondSectionDataFields, setFormSecondSectionDataFields] = useState<IDisabledVetSecondSection>();
    const [formThirdSectionDataFields, setFormThirdSectionDataFields] = useState<IDisabledVetThirdSection>();
    const [formFourthSectionDataFields, setFormFourthSectionDataFields] = useState<IDisabledVetFourthSection>();
    const [formFifthSectionDataFields, setFormFifthSectionDataFields] = useState<IDisabledVetFifthSection>();
    const [formSixthSectionDataFields, setFormSixthSectionDataFields] = useState<IDisabledVetSixthSection>();
    const [formSeventhSectionDataFields, setFormSeventhSectionDataFields] = useState<IDisabledVetSeventhSection>();
    const [formEighthSectionDataFields, setFormEighthSectionDataFields] = useState<IDisabledVetEighthSection>();

    const [secondSectionIsValid, setSecondSectionIsValid] = useState<boolean>(false);
    const [thirdSectionIsValid, setThirdSectionIsValid] = useState<boolean>(false);
    const [fourthSectionIsValid, setFourthSectionIsValid] = useState<boolean>(false);
    const [fifthSectionIsValid, setFifthSectionIsValid] = useState<boolean>(false);
    const [sixthSectionIsValid, setSixthSectionIsValid] = useState<boolean>(false);
    const [seventhSectionIsValid, setSeventhSectionIsValid] = useState<boolean>(false);
    const [eighthSectionIsValid, setEighthSectionIsValid] = useState<boolean>(false);

    const [isFormValid, setIsFormValid] = useState<boolean>(false);

    const { isFormActive } = useIsFormActive(
      isAuthorized,
      isAdminPreview,
      formSettings,
      "AdditionalDocumentation",
      selectedFormState.formFields,
      formSeventhSectionDataFields?.AdditionalDocumentation
    );
    const [showPrompt, confirmNavigation, cancelNavigation, setDisablePrompt] = useCallbackPrompt(isFormActive);

    const [showDisclaimer, setShowDisclaimer] = useState(false);
    const [showFilingWindowDisclaimer, setFilingWindowDisclaimer] = useState(false);

    useEffect(() => {
      setIsFormValid(
        secondSectionIsValid &&
        thirdSectionIsValid &&
        fourthSectionIsValid &&
        fifthSectionIsValid &&
        sixthSectionIsValid &&
        seventhSectionIsValid &&
        eighthSectionIsValid)
    }, [
      secondSectionIsValid,
      thirdSectionIsValid,
      fourthSectionIsValid,
      fifthSectionIsValid,
      sixthSectionIsValid,
      seventhSectionIsValid,
      eighthSectionIsValid
    ])

    useEffect(() => {
      return () => {
        selectedFormDispatch({
          type: SelectedFormActionsEnum.CLEAR,
          payload: {
            errorMessage: undefined,
            isLoading: undefined,
            formFields: undefined,
            successMessage: undefined,
            form: undefined,
            formSettings: undefined,
            formEntry: undefined,
            status: SelectedFormActionsEnum.CLEAR
          },
        });
      }
    }, []);

    useEffect(() => {
      const disclaimerFormText = formState.forms?.find(x => x.name === DisabledVetFormName)?.disclaimerText ?? "";
      const FilingWindowPopUpDisclaimerFormText = formState.forms?.find(x => x.name === DisabledVetFormName)?.nonFillableMessage ?? "";
      if (!formEntryId && disclaimerFormText.trim().length > 0) {
        setShowDisclaimer(true);
      }
      if (!formEntryId && FilingWindowPopUpDisclaimerFormText.trim().length > 0) {
          setFilingWindowDisclaimer(true);
        }
    }, [formEntryId, formState?.forms]);

    useEffect(() => {
      if (!formState.forms.length) {
        onLoadForms(formDispatch);
      }
    }, []);

    useEffect(() => {
      const stateFormId = formState?.forms?.find(x => x.name == DisabledVetFormName)?.id ?? formId;
      if (stateFormId && isAuthorized) {
        if (formEntryId) {
          getSelectedFormEntryDataHelper(selectedFormDispatch, stateFormId, formEntryId);
        } else {
          getSelectedFormDataHelper(selectedFormDispatch, stateFormId);
        }
      }
    }, [formState.forms]);
    
    useEffect(() => {
      if (selectedFormState?.formEntry) {
        if (selectedFormState.form?.name) {
          setFormEntry({
            ...selectedFormState?.formEntry,
            formName: selectedFormState.form?.name
          });
        } else {
          setFormEntry(selectedFormState.formEntry)
        }
      }
    }, [selectedFormState.formEntry, selectedFormState.form]);

    function ClearData() {
      setFormDataFields([]);
      setFormEntry(undefined);
      setFormSecondSectionDataFields({});
      setFormThirdSectionDataFields({});
      setFormFourthSectionDataFields({});
      setFormFifthSectionDataFields({});
      setFormSixthSectionDataFields({});
      setFormSeventhSectionDataFields({});
      setFormEighthSectionDataFields({});
      setSecondSectionIsValid(false);
      setThirdSectionIsValid(false);
      setFourthSectionIsValid(false);
      setFifthSectionIsValid(false);
      setSixthSectionIsValid(false);
      setSeventhSectionIsValid(false);
      setEighthSectionIsValid(false);

      setDisablePrompt(false);
    }

    useEffect(() => {
      if (selectedFormState.status === SelectedFormActionsEnum.CLEAR) {
        ClearData();
        return;
      }

      setFormDataFields(selectedFormState.formFields);
      const SecondSection: IDisabledVetSecondSection = DisabledVetSecondSectionInterface();
      const ThirdSection: IDisabledVetThirdSection = DisabledVetThirdSectionInterface();
      const FourthSection: IDisabledVetFourthSection = DisabledVetFourthSectionInterface();
      const FifthSection: IDisabledVetFifthSection = DisabledVetFifthSectionInterface();
      const SixthSection: IDisabledVetSixthSection = DisabledVetSixthSectionInterface();
      const SeventhSection: IDisabledVetSeventhSection = DisabledVetSeventhSectionInterface();
      const EighthSection: IDisabledVetEighthSection = DisabledVetEighthSectionInterface();

      selectedFormState?.formFields.forEach((f) => {
        let value;
        switch (f.type) {
          case "boolean":
          case "object":
            value = JSON.parse(f.value);
            break;
          case "string":
            value = f.value?.trim();
            break;
          case "number":
            value = +f.value;
            break;
        }

        switch(true) {
          case f.name in SecondSection:
            (SecondSection as any)[f.name] = value;
            break;
          case f.name in ThirdSection:
            (ThirdSection as any)[f.name] = value;
            break;
          case f.name in FourthSection:
            (FourthSection as any)[f.name] = value;
            break;
          case f.name in FifthSection:
            (FifthSection as any)[f.name] = value;
            break;
          case f.name in SixthSection:
            (SixthSection as any)[f.name] = value;
            break;
          case f.name in SeventhSection:
            (SeventhSection as any)[f.name] = value;
            break;
          case f.name in EighthSection:
            (EighthSection as any)[f.name] = value;
            break;
        }
      });
      if (selectedFormState.formFields.length > 0) {
        setFormSecondSectionDataFields(SecondSection);
        setFormThirdSectionDataFields(ThirdSection);
        setFormFourthSectionDataFields(FourthSection);
        setFormFifthSectionDataFields(FifthSection);
        setFormSixthSectionDataFields(SixthSection);
        setFormSeventhSectionDataFields(SeventhSection);
        setFormEighthSectionDataFields(EighthSection);
      }
    }, [selectedFormState.formFields]);

    useFormSectionDataFields({
      sectionFields: formSecondSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formThirdSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formFourthSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formFifthSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formSixthSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formSeventhSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formEighthSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    const navigate = useNavigate();

    function saveHandler() {
      setDisablePrompt(true);
      const temp = {
        ...formEntry,
        formName: selectedFormState.form?.name,
        submissionStatus: "Saved",
      } as IFormEntryModel;
      setFormEntry(temp);
      if (selectedFormState.form?.name) {
        saveFormHelper(selectedFormDispatch, selectedFormState.form?.name, temp, formDataFields!, navigate);
      }
    }

    function submitHandler() {
      const temp = {
        ...formEntry,
        formName: selectedFormState.form?.name,
        submissionStatus: "Submitted",
      } as IFormEntryModel;
      setFormEntry(temp);
      setDisablePrompt(true);

      if (selectedFormState.form?.name) {
        saveFormHelper(selectedFormDispatch, selectedFormState.form?.name, temp, formDataFields!, navigate);
      }
    }

    function setFormEntryBase64Url(url: string) {
      setFormEntry({ ...formEntry, pdfBase64Url: url } as IFormEntryModel);
    }

    const [visible, setVisible] = useState<boolean>(false);
    const [submit, setSubmit] = useState<boolean>(false);

    const toggleDialog = () => {
      setVisible(!visible);
    };

    const toggleSubmitDialog = () => {
      setSubmit(!submit);
      setVisible(!visible);
    };

    const dialogTitle = (
      <div>
        {submit && formEntry?.submissionStatus != "Submitted" && (
          <button className="button" onClick={submitHandler}>
            submit form
          </button>
        )}
      </div>
    );

    return <>
      <div className={classes.form}>
        {visible && (
          <Dialog
            className="customFormDialog"
            title={dialogTitle}
            onClose={submit ? toggleSubmitDialog : toggleDialog}
            width={"70vw"}
            height={"90vh"}
          >
            <DisabledVetFormPDFView
              getPdfBase64Url={setFormEntryBase64Url}
              formDataFieldsSecondSection={formSecondSectionDataFields}
              formDataFieldsThirdSection={formThirdSectionDataFields}
              formDataFieldsFourthSection={formFourthSectionDataFields}
              formDataFieldsFifthSection={formFifthSectionDataFields}
              formDataFieldsSixthSection={formSixthSectionDataFields}
              formDataFieldsSeventhSection={formSeventhSectionDataFields}
              formDataFieldsEighthSection={formEighthSectionDataFields}
            />
          </Dialog>
        )}

        <FormHeader
          formName={DisabledVetFormName}
          isAdminPreview={isAdminPreview}
          isAuthorized={isAuthorized}
          formEntry={formEntry}
          formSettings={formSettings}
          isFormValid={isFormValid}
          onPrint={() => toggleDialog()}
          onSave={() => saveHandler()}
          onSubmit={() => toggleSubmitDialog()}
        />

        <DisabledVetFormFirstSection />

        <DisabledVetFormSecondSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formSecondSectionDataFields}
          formEntry={formEntry}
          setFormDataFields={setFormSecondSectionDataFields}
          setFormIsValid={setSecondSectionIsValid}
          selectedFormDispatch={selectedFormDispatch}
        />

        <DisabledVetThirdSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formThirdSectionDataFields}
          setFormDataFields={setFormThirdSectionDataFields}
          setFormIsValid={setThirdSectionIsValid}
        />

        <DisabledVetFourthSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formFourthSectionDataFields}
          formDataFieldsSecondSection={formSecondSectionDataFields}
          setFormDataFields={setFormFourthSectionDataFields}
          setFormIsValid={setFourthSectionIsValid}
        />

        <DisabledVetFifthSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formEntry={formEntry}
          formDataFields={formFifthSectionDataFields}
          setFormDataFields={setFormFifthSectionDataFields}
          setFormIsValid={setFifthSectionIsValid}
          selectedFormDispatch={selectedFormDispatch}
        />

        <DisabledVetSixthSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formSixthSectionDataFields}
          formEntry={formEntry}
          setFormDataFields={setFormSixthSectionDataFields}
          setFormIsValid={setSixthSectionIsValid}
          selectedFormDispatch={selectedFormDispatch}
        />

        <DisabledVetSeventhSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formEntry={formEntry}
          formDataFields={formSeventhSectionDataFields}
          setFormDataFields={setFormSeventhSectionDataFields}
          setFormIsValid={setSeventhSectionIsValid}
          selectedFormDispatch={selectedFormDispatch}
        />

        <DisabledVetEighthSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formEighthSectionDataFields}
          setFormDataFields={setFormEighthSectionDataFields}
          setFormIsValid={setEighthSectionIsValid}
        />

        {(!isFormValid && !formSettings?.isReadOnly) &&
          <div className={classes.invalidForm}>
            <h2>Please Fill All Required Fields in Steps:</h2>
            {!secondSectionIsValid &&
              <div className={classes.item}>
                2.   Property Owner/Applicant
              </div>}
            {!thirdSectionIsValid &&
              <div className={classes.item}>
                3.   Authorized Representative
              </div>}
            {!fourthSectionIsValid &&
              <div className={classes.item}>
                4.   Property Descriptions
              </div>}
            {!fifthSectionIsValid &&
              <div className={classes.item}>
                5.   Type of Exemption and Qualifications
              </div>}
            {!sixthSectionIsValid &&
              <div className={classes.item}>
                6.   Award Verification Letter
              </div>}
            {!seventhSectionIsValid &&
              <div className={classes.item}>
                7.    Additional Documentation
              </div>}
            {!eighthSectionIsValid &&
              <div className={classes.item}>
                8.   Certification and Signature
              </div>}
          </div>}

        {isAuthorized && !isAdminPreview &&
          !formSettings?.isReadOnly &&
          formEntry?.submissionStatus != "Submitted" && (
            <span className="buttons-group">
              <button disabled={!isFormValid}
                className="button"
                onClick={() => toggleSubmitDialog()}
              >
                <i className="fa fa-tasks fa-fw"></i>
                Review & Submit
              </button>
            </span>
          )}
      </div>
      {showDisclaimer && (
      <DisabledVetDisclaimer 
          disclaimerText={formState?.forms?.find(x => x.name == DisabledVetFormName)?.disclaimerText?.trim() || ""}
          onClose={() => setShowDisclaimer(false)} />)}
      {showFilingWindowDisclaimer && (
                <DisabledVetFilingWindowDisclaimer 
                    disclaimerText={formState?.forms?.find(x => x.name == DisabledVetFormName)?.nonFillableMessage?.trim() || ""}
                    onClose={() => setFilingWindowDisclaimer(false)} />)} 
      {(loading || isLoading) && <CustomLoader />}
      {showPrompt && isAuthorized && (!loading && !isLoading) && (
        <UnsavedFormDialog
          onConfirm={confirmNavigation}
          onCancel={cancelNavigation}
        />
      )}
    </>
  }